<div class="sw-cms-el-config-moorl-newsletter">
    <sw-tabs
        class="sw-cms-el-config-moorl-newsletter__tabs"
        default-item="general"
    >
        <template #default="{ active }">
            <sw-tabs-item
                name="general"
                :activeTab="active"
            >
                {{ $tc('sw-cms.elements.moorl-newsletter.tab.general') }}
            </sw-tabs-item>
            <sw-tabs-item
                name="colors"
                :activeTab="active"
            >
                {{ $tc('sw-cms.elements.moorl-newsletter.tab.colors') }}
            </sw-tabs-item>
            <sw-tabs-item
                name="text"
                :activeTab="active"
            >
                {{ $tc('sw-cms.elements.moorl-newsletter.tab.text') }}
            </sw-tabs-item>
        </template>

        <template #content="{ active }">
            <sw-container
                v-if="active === 'general'"
                class="sw-cms-el-config-moorl-newsletter__tab-general"
            >
                <mt-switch
                    bordered
                    :label="$tc('sw-cms.elements.moorl-newsletter.config.optin')"
                    v-model="element.config.optin.value"
                />
            </sw-container>
            <sw-container
                v-if="active === 'colors'"
                class="sw-cms-el-config-moorl-newsletter__tab-colors"
            >
                <mt-colorpicker
                    colorOutput="hex"
                    :zIndex="1000"
                    :label="$tc('sw-cms.elements.moorl-newsletter.config.buttonBackground')"
                    v-model="element.config.buttonBackground.value"
                />
                <mt-colorpicker
                    colorOutput="hex"
                    :zIndex="1000"
                    :label="$tc('sw-cms.elements.moorl-newsletter.config.buttonTextColor')"
                    v-model="element.config.buttonTextColor.value"
                />
                <mt-colorpicker
                    colorOutput="hex"
                    :zIndex="1000"
                    :label="$tc('sw-cms.elements.moorl-newsletter.config.privacyColor')"
                    v-model="element.config.privacyColor.value"
                />
            </sw-container>
            <sw-container
                v-if="active === 'text'"
                class="sw-cms-el-config-moorl-newsletter__tab-text"
            >
                <mt-banner variant="info">
                    {{ $tc('sw-cms.elements.moorl-newsletter.config.hint') }}
                </mt-banner>
                <mt-text-field
                    v-model="element.config.placeholder.value"
                    :label="$tc('sw-cms.elements.moorl-newsletter.config.placeholder')"
                />
                <mt-text-field
                    v-model="element.config.buttonText.value"
                    :label="$tc('sw-cms.elements.moorl-newsletter.config.')"
                />
            </sw-container>
        </template>
    </sw-tabs>
</div>